/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { locationAdapter, LocationState, LOCATIONS_KEY } from './locations.reducer';

const { selectAll, selectEntities } = locationAdapter.getSelectors();

const getLocationsState = createFeatureSelector<LocationState>(LOCATIONS_KEY);

export const getLocations = createSelector(getLocationsState, (state: LocationState) => ({
  locations: selectAll(state.locations),
  loaded: state.loaded,
}));

export const getLocation = (locationId: number) =>
  createSelector(getLocationsState, (state: LocationState) => ({
    location: selectEntities(state.locations)[locationId],
    loaded: state.loaded,
  }));
